/* premium-video: lazy-load + play-in-view + pause-offscreen for [data-premium-video].
   One shared IntersectionObserver. Respects prefers-reduced-motion. Degrades to poster. */
(function () {
  if (window.__premiumVideoInit) return;
  window.__premiumVideoInit = true;

  function init() {
    var vids = document.querySelectorAll('video[data-premium-video]');
    if (!vids.length) return;

    // Reduced motion: leave the poster, never load or play the video.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function load(video) {
      if (video.dataset.loaded) return;
      video.dataset.loaded = '1';
      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].src = sources[i].getAttribute('data-src');
      }
      video.load();
    }

    function play(video) {
      load(video);
      video.muted = true; // required for autoplay; set in JS too (iOS quirk)
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked (e.g. Low Power Mode): poster remains */ });
    }

    function markPlaying(e) {
      e.target.classList.add('is-playing');
      var box = e.target.closest('.premium-video');
      if (box) box.classList.add('is-playing'); // hides the poster so a blended (translucent) video doesn't show the still underneath
    }

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < vids.length; i++) { vids[i].addEventListener('playing', markPlaying); play(vids[i]); }
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) play(v);
        else if (v.dataset.loaded) v.pause();
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    vids.forEach(function (v) {
      v.addEventListener('playing', markPlaying);
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
